import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=5d6808db"
var script = {}
import style0 from "./Manifest.vue?vue&type=style&index=0&id=5d6808db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports